<template>
  <div class="tw-benchmark-header">
    <TwBenchmarkControlsBar
      :csv-can-download="csvCanDownload"
      :csv-download="csvDownload"
      @open-filter="filterVisible = true"
      @open-tag-management="tagManagementVisible = true"
      @open-table-setting="tableSettingVisible = true"
    />

    <TwBenchmarkFilterPanel
      :start-datetime="dateRange.range.value[0]"
      :end-datetime="dateRange.range.value[1]"
      :visible="filterVisible"
      @search="onSearch"
      @clear="onClear"
      @close="filterVisible = false"
    />

    <TwBenchmarkTagManagementDialog :visible="tagManagementVisible" @close="tagManagementVisible = false" />
    <TwBenchmarkTableSettingDialog :visible="tableSettingVisible" @close="tableSettingVisible = false" />
  </div>
</template>

<script lang="ts">
import moment from 'moment'
import { defineComponent, PropType, ref, watch } from 'vue'

import { type SearchFilters } from '@/typings/twitter_benchmark_campaign_posts'

import { type UseCampaignDateRangeFilter } from '../../hooks/useCampaignDateRangeFilter'
import { type CsvDownloadResult } from '../../hooks/useTwBenchmarkCsvDownload'
import { useTwBenchmarkPostsStore } from '../../store/useTwBenchmarkPostsStore'
import {
  TwBenchmarkControlsBar,
  TwBenchmarkFilterPanel,
  TwBenchmarkTableSettingDialog,
  TwBenchmarkTagManagementDialog
} from './components'

/**
 * X 競合分析ヘッダー
 */
export default defineComponent({
  name: 'TwBenchmarkHeader',

  components: {
    TwBenchmarkControlsBar,
    TwBenchmarkFilterPanel,
    TwBenchmarkTagManagementDialog,
    TwBenchmarkTableSettingDialog
  },

  props: {
    dateRange: {
      type: Object as PropType<UseCampaignDateRangeFilter>,
      required: true
    },
    csvCanDownload: {
      type: Boolean,
      default: false
    },
    csvDownload: {
      type: Function as PropType<() => Promise<CsvDownloadResult>>,
      default: undefined
    }
  },

  setup(props) {
    const postsStore = useTwBenchmarkPostsStore()

    const tagManagementVisible = ref(false)
    const tableSettingVisible = ref(false)

    const PICKER_FORMAT = 'YYYY-MM-DD HH:mm'

    watch(
      () => postsStore.searchFilters,
      filters => {
        if (filters.startDatetime && filters.endDatetime) {
          props.dateRange.setRange([
            moment(filters.startDatetime).format(PICKER_FORMAT),
            moment(filters.endDatetime).format(PICKER_FORMAT)
          ])
        }
      },
      { immediate: true, deep: true }
    )

    const filterVisible = ref(false)

    const onSearch = (filters: SearchFilters): void => {
      void postsStore.applyFilters(filters)
    }

    const onClear = (): void => {
      void postsStore.clearFilters()
    }

    return {
      tagManagementVisible,
      tableSettingVisible,
      filterVisible,
      onSearch,
      onClear
    }
  }
})
</script>

<style lang="scss" scoped>
.tw-benchmark-header {
  margin-bottom: 16px;
}
</style>
